import axios from "axios";
export const state = {
    agent_stock: [],
    agents: [],
    filter_status: false,
    save_status: false,
    disbursement_cart: [],
    disbursements: [],
    stockreturn_cart: [],
    pendingspoilt: [],
    stockreturns: [],
    stockvalue: [],
    agent_disbursements:[],
    reconcilations:[]

};
export const getters = {
    AgentStock: state => state.agent_stock.data,
    Agents: state => state.agents,
    FilterStatus: state => state.filter_status,
    SaveStatus: state => state.save_status,
    DisbursementCart: state => state.disbursement_cart.data,
    Disbursements: state => state.disbursements.data,
    StockreturnCart: state => state.stockreturn_cart.data,
    PendingSpoilt: state => state.pendingspoilt.data,
    Stockreturns: state => state.stockreturns.data,
    StockValue: state => state.stockvalue,
    AgentDisbursements: state => state.agent_disbursements.data,
    Reconcilations: state => state.reconcilations.data,
};

export const mutations = {
    SET_AGENTS(state, newValue) {
        state.agents = newValue
    },
    SET_AGENTSTOCK(state, newValue) {
        state.agent_stock = newValue
    },
    SET_FILTERSTATUS(state, newValue) {
        state.filter_status = newValue
    },
    SET_SAVE_STATUS(state, newValue) {
        state.save_status = newValue
    },
    SET_DISBURSEMENT_CART(state, newValue) {
        state.disbursement_cart = newValue
    },
    SET_DISBURSEMENTS(state, newValue) {
        state.disbursements = newValue
    },
    SET_AGENT_DISBURSEMENTS(state, newValue) {
        state.agent_disbursements = newValue
    },
    SET_STOCKRETURN_CART(state, newValue) {
        state.stockreturn_cart = newValue
    },
    SET_PENDINGSPOILT(state, newValue) {
        state.pendingspoilt = newValue
    },
    SET_STOCKRETURNS(state, newValue) {
        state.stockreturns = newValue
    },
    SET_STOCKVALUE(state, newValue) {
        state.stockvalue = newValue
    },
    SET_RECONCILATIONS(state, newValue) {
        state.reconcilations = newValue
    },

};

export const actions = {

    fetchAgentstock({ commit }, id) {
        commit('SET_FILTERSTATUS', true)
        axios.get(`agent_stock/${id}`).then(ec_res => {
            commit('SET_AGENTSTOCK', ec_res.data)
            commit('SET_FILTERSTATUS', false)
        })
    },

    fetchAgents({ commit }) {
        axios.get('agents').then(ec_res => {
            commit('SET_AGENTS', ec_res.data)
        })
    },

    // Disbursement Cart
    fetchDisbursementCart({ commit }) {
        axios.get('disbursements_cart').then(ec_res => {
            commit('SET_DISBURSEMENT_CART', ec_res.data)
        })
    },


    addToDisbursementCart({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('disbursements_cart', payload).then(() => {
            dispatch('fetchDisbursementCart');
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Adding Product to cart " + error }
            dispatch('notification/error', message, { root: true })
        })
    },
    editDisbursementCart({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`disbursements_cart/${payload.id}`, payload).then(() => {
            dispatch('fetchDisbursementCart');
            let message = { 'msg': `Product ${payload.name} updated successfully in cart` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error updating Product in cart" }
            dispatch('notification/error', message, { root: true })
        })
    },
    deleteDisbursementCart({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.delete(`disbursements_cart/${payload.id}`).then(() => {
            dispatch('fetchDisbursementCart');
            let message = { 'msg': `Product ${payload.name} deleted from cart successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error in deleting Product from cart " + error }
            dispatch('notification/error', message, { root: true })
        })
    },



    //Disbursement
    fetchDisbursement({ commit }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('fetchdisbursements', payload).then(ec_res => {
            commit('SET_SAVE_STATUS', false);
            commit('SET_DISBURSEMENTS', ec_res.data)
        })
    },

    fetchAgentDisbursement({ commit }) {
        axios.get('agent_disbursements').then(ec_res => {
            commit('SET_AGENT_DISBURSEMENTS', ec_res.data)
        })
    },

    addToDisbursement({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('disbursements', payload).then(() => {
            dispatch('fetchDisbursementCart');
            let message = { 'msg': `Item disbursement submitted successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error submitting disbursement " + error }
            dispatch('notification/error', message, { root: true })
        })
    },
    editDisbursement({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`disbursements/${payload.id}`, payload).then(() => {
            dispatch('fetchDisbursement');
            let message = { 'msg': `Disbursement record updated successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error updating Disbursement" }
            dispatch('notification/error', message, { root: true })
        })
    },
    deleteDisbursement({ commit, dispatch }, id) {
        commit('SET_SAVE_STATUS', true);
        axios.delete(`disbursements/${id}`).then(() => {
            dispatch('fetchDisbursement');
            let message = { 'msg': `Disbursement has been deleted successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error in deleting Disbursement " + error }
            dispatch('notification/error', message, { root: true })
        })
    },

    receiveDisbursement({ commit, dispatch }, id) {
        commit('SET_SAVE_STATUS', true);
        axios.post(`receive_disbursements/${id}`).then(() => {
            dispatch('fetchDisbursement');
            let message = { 'msg': `Disbursement has been received successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error in receiving Disbursement " + error }
            dispatch('notification/error', message, { root: true })
        })
    },

    rejectDisbursement({ commit, dispatch }, id) {
        commit('SET_SAVE_STATUS', true);
        axios.post(`reject_disbursements/${id}`).then(() => {
            dispatch('fetchDisbursement');
            let message = { 'msg': `Disbursement has been rejected successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error in rejecting Disbursement " + error }
            dispatch('notification/error', message, { root: true })
        })
    },


    // Stock return Cart
    fetchStockreturnCart({ commit }) {
        axios.get('agent_stockreturn_cart').then(ec_res => {
            commit('SET_STOCKRETURN_CART', ec_res.data)
        })
    },

    addToStockreturnCart({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('agent_stockreturn_cart', payload).then(() => {
            dispatch('fetchStockreturnCart');
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Adding Product to cart " + error }
            dispatch('notification/error', message, { root: true })
        })
    },
    editStockreturnCart({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`agent_stockreturn_cart/${payload.id}`, payload).then(() => {
            dispatch('fetchStockreturnCart');
            let message = { 'msg': `Product ${payload.name} updated successfully in cart` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error updating Product in cart" }
            dispatch('notification/error', message, { root: true })
        })
    },
    deleteStockreturnCart({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.delete(`agent_stockreturn_cart/${payload.id}`).then(() => {
            dispatch('fetchStockreturnCart');
            let message = { 'msg': `Product ${payload.name} deleted from cart successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error in deleting Product from cart " + error }
            dispatch('notification/error', message, { root: true })
        })
    },
    //
    addReturnedstock({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('agent_stockreturn', payload).then(() => {
            dispatch('fetchStockreturnCart');
            let message = { 'msg': `Item disbursement submitted successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error submitting disbursement " + error }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Spoilt Stock/Exchanges
    // Fetch 
    fetchPendingSpoilt({ commit }) {
        axios.get('agent_damages').then(ec_res => {
            commit('SET_PENDINGSPOILT', ec_res.data)
        })
    },
    addSpoilt({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('agent_damages', payload).then(() => {
            dispatch('fetchPendingSpoilt');
            let message = { 'msg': `Spoilt Product awaits confirmation as spoilt ` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Adding Spoilt Stock " }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Confirm 
    ConfirmSpoilt({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.get(`confirm_agent_damages/${payload.id}`, payload).then(() => {
            dispatch('fetchPendingSpoilt');
            let message = { 'msg': `item ${payload.name} spoilt stock record has been successfully confirmed` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Confirming Spoilt Stock " }
            dispatch('notification/error', message, { root: true })
        })
    },


    // Reject Spoilt Stock
    RejectSpoilt({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.get(`reject_agent_damages/${payload.id}`, payload).then(() => {
            dispatch('fetchPendingSpoilt');
            let message = { 'msg': `item ${payload.name} spoilt stock record has been successfully rejected` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Rejecting Spoilt Stock " }
            dispatch('notification/error', message, { root: true })
        })
    },


    deleteSpoilt({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.delete(`agent_damages/${payload.id}`).then(() => {
            dispatch('fetchPendingSpoilt');
            let message = { 'msg': `Spoilt stock record deleted successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error " + error }
            dispatch('notification/error', message, { root: true })
        })
    },


    fetchAgentstockReturns({ commit }) {
        commit('SET_FILTERSTATUS', true)
        axios.get(`agent_stockreturn`).then(ec_res => {
            commit('SET_STOCKRETURNS', ec_res.data)
            commit('SET_FILTERSTATUS', false)
        })
    },

    fetchAgentstockValue({ commit }) {
        commit('SET_FILTERSTATUS', true)
        axios.get(`agentstock_value`).then(ec_res => {
            commit('SET_STOCKVALUE', ec_res.data)
            commit('SET_FILTERSTATUS', false)
        })
    },

    // Stock roconciliation
    addQty({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`agent_reconciliation/${payload.product_id}`, payload).then(() => {
            dispatch('fetchAgentstock', payload.agent);
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
        })
    },
    SaveReconcile({ commit, dispatch }) {
        commit('SET_SAVE_STATUS', true);
        axios.post('save__agent_reconciliation').then(() => {
            let message = { 'msg': `Stock Reconciled successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Reconciling Stock" }
            dispatch('notification/error', message, { root: true })
        })
    },

    fetchReconcilations({ commit }) {
        commit('SET_FILTERSTATUS', true)
        axios.get(`agent_reconciliation`).then(ec_res => {
            commit('SET_RECONCILATIONS', ec_res.data)
            commit('SET_FILTERSTATUS', false)
        })
    },

    // Confirm Stockreturn
    ConfirmStockreturn({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.get(`confirm_stockreturns/${payload.id}`, payload).then(() => {
            dispatch('fetchAgentstockReturns');
            let message = { 'msg': `Item ${payload.name} stock return record has been successfully confirmed` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Confirming Spoilt Stock " }
            dispatch('notification/error', message, { root: true })
        })
    },


    // Reject Stockreturn
    RejectStockreturn({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.get(`reject_stockreturns/${payload.id}`, payload).then(() => {
            dispatch('fetchAgentstockReturns');
            let message = { 'msg': `Item ${payload.name} stock return record has been successfully rejected` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Rejecting Spoilt Stock " }
            dispatch('notification/error', message, { root: true })
        })
    },


    // Delete Stockreturn
    DeleteStockreturn({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.delete(`agent_stockreturns/${payload.id}`).then(() => {
            dispatch('fetchAgentstockReturns');
            let message = { 'msg': `Stock return record deleted successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error " + error }
            dispatch('notification/error', message, { root: true })
        })
    },

};